import { useRouter } from "next/router";

export const useRouteParamNumber = (key: string): [number | null, boolean] => {
  const router = useRouter();
  const value = +router.query[key];
  if (isNaN(value)) return [null, false];
  return [value, true];
};

export const useRouteParamString = (key: string): [string | null, boolean] => {
  const router = useRouter();
  const value = router.query[key];
  if (typeof value === "object") return [null, false];
  return [value, true];
};
